import React from 'react';
import { Alert, AlertVariant, classNames } from '../atoms';
import Page, { PageProps } from './Page';

export interface PageStatusProps extends PageProps {
  alertVariant?: AlertVariant;
  centered?: boolean;
}

const PageStatus: React.FC<PageStatusProps> = ({
  alertVariant,
  centered = false,
  className,
  children,
  ...props
}) => (
  <Page
    className={classNames(centered ? 'text-center' : undefined, className)}
    {...props}
  >
    {alertVariant ? (
      <Alert variant={alertVariant}>{children}</Alert>
    ) : children}
  </Page>
);

export default PageStatus;
